export enum AIFeature {
  QuoteCompare = 'QuoteCompare',
  QuoteGeneration = 'QuoteGeneration',
  SubmissionAcknowledgment = 'SubmissionAcknowledgment',
  ProductRecommendation = 'ProductRecommendation',
  QuoteBinderCompare = 'QuoteBinderCompare',
  BinderPolicyCompare = 'BinderPolicyCompare',
  QuotePolicyCompare = 'QuotePolicyCompare',
  QuoteToExpiringCompare = 'QuoteToExpiringCompare',
  SubmissionRiskAssessment = 'SubmissionRiskAssessment',
  ProposalGeneration = 'ProposalGeneration',
  MarketingUpdateGeneration = 'MarketingUpdateGeneration',
  MarketSummary = 'MarketSummary',
  MarketingEmailGeneration = 'MarketingEmailGeneration',
  SubmissionAIAssistant = 'SubmissionAIAssistant',
  ActualPremiumCalculation = 'ActualPremiumCalculation',
}
